import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from '@services/infra/config.service';
import {APP_INFO} from '@environments/version';
import {SESSION_STORAGE, StorageService} from 'ngx-webstorage-service';

@Injectable()
export class LoggingService {
  constructor(
    private readonly http: HttpClient,
    private readonly conf: ConfigService,
    @Inject(SESSION_STORAGE) private readonly storage: StorageService,
  ) {}

  public logError(message: string): void {
    const user = this.currentUser();
    const body = {loglevel: 'ERROR', msg: message, app_info: APP_INFO, user, userAgent: window.navigator.userAgent};
    this.postMsg(body);
  }
  public logInfo(message: string, additionalInformation: object): void {
    const user = this.currentUser();
    const body = {loglevel: 'INFO', msg: message, info: {...additionalInformation, user}, app_info: APP_INFO, userAgent: window.navigator.userAgent};
    this.postMsg(body);
  }
  private currentUser() {
    return this.storage.get('currentUser');
  }
  private postMsg(body: object) {
    const url = this.conf.logUrl;
    if (!url) {
      console.log('would log (logging is disabled): ', body);
      return;
    }
    this.http.post(url, body, {withCredentials: true, responseType: 'text'}).subscribe();
  }
}
